/**
 * Validates a URL slug — lowercase alphanumerics + hyphens. Used by Next.js
 * dynamic route layouts to guard against malformed market codes (e.g.
 * `/[market]/...`) before letting the route render. Rejects slashes,
 * dots, schemes, and any other character that could open up path traversal
 * or open-redirect vectors.
 */
export const isValidSlug = (value: string): boolean =>
  /^[a-z0-9-]+$/.test(value)
